import React from 'react'
import NotificationDropdownCard from '../../components/Cards/NotificationDropdownCard'
import { useHistory } from 'react-router'
import XIcon from '../../components/Icons/outline/XIcon';
import { COLORS } from '../../config';
import useApp from '../../store/app/appContext';

const STYLE_MAIN = {
  width: '400px'
}
const STYLES_EDGE = {
  clipPath: 'polygon(100% 0, 0% 100%, 100% 100%)'

}
function NotificationsDropdown({ onClose, mobile }) {
  const history = useHistory();

  const { appState: { userNotifications } } = useApp();

  const handleClick = () => {
    history.push('/dashboard')
    onClose();
  }

  return (
    <div className='absolute'>
      <div className={`relative z-10 shadow pt-4 bg-white rounded transform ${!mobile && '-translate-x-full'}`} style={STYLE_MAIN}>
        <span className='bg-white w-10 h-8 absolute  top-0 right-0 transform  -translate-y-3' style={STYLES_EDGE}/>
        <div onClick={onClose} className='absolute cursor-pointer top-0 right-0 mt-3 mr-3 bg-light w-8 h-8 rounded-full flex justify-around items-center'>
          <XIcon size='w-5 h-5' stroke={COLORS.colorPrimary}/>
        </div>
        <div className='flex justify-around '>
          <span className='text-primary font-semibold'>
            NOTIFICATIONS
          </span>
        </div>
        <ul className='divide-y divide-gray-200 px-4 mt-8'>
          {userNotifications.map((notification) => (
            <li className='overflow-hidden' key={notification._id}>
              <NotificationDropdownCard notification={notification}/>
            </li>
          ))}
        </ul>
        <div className='flex justify-around bg-light py-4'>
          <span className='text-primary-light font-medium cursor-pointer' onClick={handleClick}>
            See all notifications
          </span>
        </div>
      </div>

    </div>
  )
}

export default NotificationsDropdown
